// Thư mục: src/stores/driverChecklistStore.js
import { defineStore } from "pinia";
import { ChecklistApi } from "@/services/checklistService";
// (Import fileService nếu cần)
// import fileService from "@/services/fileService";

export const useDriverChecklistStore = defineStore("driverChecklist", {
  state: () => ({
    isLoading: false,
    error: null,
    items: [], // Danh sách hạng mục cần check

    // State kết quả (nếu cần)
    submitResult: null, // { logId, hasCriticalError }
  }),
  actions: {
    /**
     * Tải danh sách hạng mục về cho tài xế
     */
    async fetchItems(xeId) {
      if (!xeId) {
        this.error = "Không tìm thấy xe được phân công.";
        return;
      }
      this.isLoading = true;
      this.error = null;
      this.items = [];
      try {
        const data = await ChecklistApi.getHangMuc(xeId);
        // Map lại, thêm trường 'result' để lưu trạng thái FE
        this.items = (data || []).map((item) => ({
          ...item, // id, tenHangMuc, moTa, mucDo, thuTu
          trangThai: null, // 'OK' hoặc 'NG' (chưa chọn)
          ghiChu: "",
          anhUrl: null,
          anhFile: null, // (File object tạm thời)
          isUploading: false,
        }));
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi tải danh sách checklist";
        console.error("fetchItems checklist error:", e);
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Nộp báo cáo checklist
     */
    async submitChecklist(payload) {
      this.isLoading = true;
      this.error = null;
      this.submitResult = null;
      try {
        // (Logic upload ảnh nên được xử lý trong component trước khi gọi action này,
        // hoặc xử lý tại đây nếu payload chứa file)

        const response = await ChecklistApi.submit(payload);
        this.submitResult = response; // Lưu kết quả
        return response; // Trả về cho component
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi nộp báo cáo checklist";
        console.error("submitChecklist error:", e);
        throw e; // Ném lỗi
      } finally {
        this.isLoading = false;
      }
    },
  },
});
